import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { isMobile } from 'react-device-detect';
import '../../mobile.css';

function Loading() {
  
  
  
    return (
      <>
      {isMobile ? 
        <div className="loadingMobile">
          <div className="containerBox" style={{marginTop:"65%"}}>
              <div className="child">
              <CircularProgress/>
              </div>
          </div>
        </div>
      :
        <div className="loading">
           <div className="load">
            <CircularProgress  style={{marginLeft:"42%",marginTop:"40%"}}/>
          </div>
        </div>
      }
</>

  )
    
}
  
export default Loading;
